export const roundToNearestTenCents = (amount) => {
  return Math.round(amount * 10) / 10
}